import { IParamsSendQuestions } from "../2_Entities/SendQuestions";
import IAdmissionRepository from "../4_Repositories/IAdmissionRepository";


export default class PostSendQuestionsUseCase {
  private readonly _repository: IAdmissionRepository;

  constructor(repository: IAdmissionRepository) {
    this._repository = repository;
  }

  public async execute(admissionExamId: string, quizzesId: string, params: IParamsSendQuestions) {
    const entities = await this._repository.sendQuestion(
      admissionExamId,
      quizzesId,
      params
    );

    return entities;
  }
}
